/**
 * Returns a preview of the list:
 * - If list.length <= max, returns all items.
 * - If list.length > max, returns (max - 1) items and the remainder count.
 */
export function getListPreview<T>(list: T[], max: number = 3) {
    if (list.length <= max) {
        return { previewItems: list, remainder: 0 };
    }
    return { previewItems: list.slice(0, max - 1), remainder: list.length - (max - 1) };
}
